import type { ApiClient } from '@fusapp-work/api'
import { useCurrentSession } from '../composables/useCurrentSession'
import { consoleLoginLocation, consoleReturnPath } from './consoleReturn'

export interface RouteLike {
  readonly name?: string | symbol | null
  readonly fullPath?: string
  readonly query?: Readonly<Record<string, unknown>>
}

export type GuardResult = true | { readonly name: 'login' | 'forbidden' | 'home'; readonly query?: { readonly returnTo: string } } | string

export function createSessionGuard(apiClient: ApiClient): (to: RouteLike) => Promise<GuardResult> {
  return async function sessionGuard(to: RouteLike): Promise<GuardResult> {
    const session = useCurrentSession()
    // Terminal hedefe yönlendirmede çözülmüş sonucu tekrar kullanırız.
    // Doğrudan ziyaret/yenileme idle başlar; /login dahil sunucuya ilk kez sorulur.
    if (to.name === 'forbidden' && session.state.status === 'forbidden') return true
    if (to.name === 'login' && (session.state.status === 'unauthenticated' || session.state.status === 'error')) return true
    if (session.state.status === 'unauthenticated') return consoleLoginLocation(to.fullPath)

    const state = await session.resolve(apiClient)
    // Successful authentication preserves approved protected deep links. Only
    // public auth entry points resume only a validated local return hint.
    if (state.status === 'authenticated' && to.name && to.name !== 'login' && to.name !== 'forbidden') return true
    const returnTo = consoleReturnPath(to.query?.returnTo)
    if (state.status === 'authenticated' && to.name === 'login' && returnTo) return returnTo
    const destination = state.status === 'authenticated' ? 'home'
      : state.status === 'forbidden' ? 'forbidden' : 'login'
    if (to.name === destination) return true
    return destination === 'login' ? consoleLoginLocation(to.fullPath) : { name: destination }
  }
}
